/** @format */
'use client';
import CentredLoadingSpinner from '@atoms/CentredLoadingSpinner';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { ScrollView } from 'devextreme-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface ILeaderboardTabConfig {
  id: string;
  icon: IconName;
  title: React.ReactNode;
  records: any[];
  render: (record: any) => React.ReactNode;
  loading: boolean;
}

const LeaderboardTabView = ({ data }: { data: ILeaderboardTabConfig }) => {
  return (
    <ScrollView showScrollbar={'onHover'} height={'100%'}>
      {data.loading ? (
        <CentredLoadingSpinner />
      ) : data.records.length ? (
        data.records.map((r) => <div key={r.id}>{data.render(r)}</div>)
      ) : (
        <div style={{ height: '100%', display: 'grid', placeItems: 'center', padding: '16px' }}>
          <FormattedMessage defaultMessage={'No Results Found'} description={'Notification that a search did not find any results'} />
        </div>
      )}
    </ScrollView>
  );
};

export default LeaderboardTabView;
